export default "__VITE_ASSET__C4Did$6z__"